import {
  GET_TRAINING_COURSE_CATEGORIES,
  GET_TRAINING_COURSE_CATEGORY,
  CREATE_TRAINING_COURSE_CATEGORY,
  UPDATE_TRAINING_COURSE_CATEGORY,
  DESTROY_TRAINING_COURSE_CATEGORY,
} from "./actions";

export function TrainingCourseCategoryReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_TRAINING_COURSE_CATEGORIES}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_TRAINING_COURSE_CATEGORY}_FULFILLED`:
    case `${CREATE_TRAINING_COURSE_CATEGORY}_FULFILLED`:
    case `${UPDATE_TRAINING_COURSE_CATEGORY}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_TRAINING_COURSE_CATEGORY}_FULFILLED`: {
      let newState = _.clone(state);
      const {
        meta: { id },
      } = action;
      _.unset(newState, id);
      return newState;
    }
    default:
      return state;
  }
}

// Move this to the reducer page
// import { TrainingCourseCategoryReducer } from "modules/training/course_categories/reducer"

// training_course_categories:TrainingCourseCategoryReducer,
